import React, { createContext, PropsWithChildren, useState } from 'react';

import UnitType from '@r6digital/rapidstor-types/react/entities/UnitType';

// Used for storing the grouped unitTypes that match the current selection
export interface UnitGroup {
    [key: string]: UnitType[];
}

export interface MapContextProps {
    units: UnitGroup;
    setUnits: React.Dispatch<React.SetStateAction<UnitGroup>>;
    firstAvailableUnit: string;
    setFirstAvailableUnit: React.Dispatch<React.SetStateAction<string>>;
}

export const MapContext = createContext<MapContextProps>({
    units: {},
    setUnits: () => {
        return;
    },
    firstAvailableUnit: '',
    setFirstAvailableUnit: () => {
        return;
    },
});

export const MapContextProvider = ({ children }: PropsWithChildren) => {
    const [units, setUnits] = useState<UnitGroup>({});
    const [firstAvailableUnit, setFirstAvailableUnit] = useState<string>('');

    return (
        <MapContext.Provider
            value={{
                units: units,
                setUnits: setUnits,
                firstAvailableUnit: firstAvailableUnit,
                setFirstAvailableUnit: setFirstAvailableUnit,
            }}
        >
            {children}
        </MapContext.Provider>
    );
};
